import { render, staticRenderFns } from "./wuju-navbar.vue?vue&type=template&id=7251b6de&"
import script from "./wuju-navbar.vue?vue&type=script&lang=js&"
export * from "./wuju-navbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports